export default {
  init() {

    $('input').on('focusin', function() {
      $(this).attr('placeholder', '');
    })

    $('.gform_wrapper > form').after('<div class="unsolict-warning"><p><span>*</span> The foundation does not accept unsolicited proposals.</p></div>')

    if ( $('#gform_submit_button_1').length > 0 ) {

    } else (
      $('.contact').addClass('after-submit')

    )


    //adding span underneath button to animate -- taken out for accessiblity QA - TF
    // $('.gform_button.button').after('<span class="input-border"></span>')

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/contact.js